/**
 * @generated SignedSource<<e6f1645872c0238cc2a3f752a39f6ac1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalendarEditUnarchiveMutation$variables = {
  calendarId: string;
};
export type CalendarEditUnarchiveMutation$data = {
  readonly store: {
    readonly calendar: {
      readonly unarchive: {
        readonly id: string;
        readonly isArchived: boolean;
      };
    };
  };
};
export type CalendarEditUnarchiveMutation = {
  response: CalendarEditUnarchiveMutation$data;
  variables: CalendarEditUnarchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "calendarId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "calendarId",
            "variableName": "calendarId"
          }
        ],
        "concreteType": "StoreCalendarMutation",
        "kind": "LinkedField",
        "name": "calendar",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreCalendar",
            "kind": "LinkedField",
            "name": "unarchive",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isArchived",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CalendarEditUnarchiveMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CalendarEditUnarchiveMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "03cb000a5e54bb56811770efd4b83e62",
    "id": null,
    "metadata": {},
    "name": "CalendarEditUnarchiveMutation",
    "operationKind": "mutation",
    "text": "mutation CalendarEditUnarchiveMutation(\n  $calendarId: ID!\n) {\n  store {\n    calendar(calendarId: $calendarId) {\n      unarchive {\n        id\n        isArchived\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6d15e604782eb4dca5184b7dd8c1d009";

export default node;
